import React from "react";

/**
 * @component MessageSolidIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <MessageSolidIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const MessageSolidIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="MessageSolidIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M22 4v12a2 2 0 01-2 2H7.995L2 22V4a2 2 0 012-2h16a2 2 0 012 2z"
        clipRule="evenodd"
      />
    </svg>
  )
);
MessageSolidIcon.displayName = "MessageSolidIcon";
export default MessageSolidIcon;
